<template>
  <div>
    <div class="mt-5 py-5 border-top text-center">
      <div class="row justify-content-center">
        <div class="col-lg-12">
          <bar-chart :chart-data="datacollection"></bar-chart>
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="col-lg-5">
  <b>เดือนก่อนหน้านี้</b>-->
  <!-- s content -->
  <!-- <div class="progress-wrapper">
                            <div class="progress-info">
                            <div class="progress-label">
                                <span>ร้านค้าที่ 1 ทำรายได้ในเดือนนี้</span>
                            </div>
                            <div class="progress-percentage">
                                <span>30%</span>
                            </div>
                            </div>
                            <div class="progress">
                            <div class="progress-bar bg-success" role="progressbar" aria-valuenow="30" aria-valuemin="0" aria-valuemax="100" style="width: 30%;"></div>
                            </div>
                        </div>

                        <div class="progress-wrapper">
                            <div class="progress-info">
                            <div class="progress-label">
                            <span>ร้านค้าที่ 2 ทำรายได้ในเดือนนี้</span>
                            </div>
                            <div class="progress-percentage">
                                <span>25%</span>
                            </div>
                            </div>
                            <div class="progress">
                            <div class="progress-bar bg-info" role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" style="width: 25%;"></div>
                            </div>
                        </div>

                        <div class="progress-wrapper">
                            <div class="progress-info">
                            <div class="progress-label">
                            <span>ร้านค้าที่ 3 ทำรายได้ในเดือนนี้</span>
                            </div>
                            <div class="progress-percentage">
                                <span>20%</span>
                            </div>
                            </div>
                            <div class="progress">
                            <div class="progress-bar bg-info" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%;"></div>
                            </div>
                        </div>

                        <div class="progress-wrapper">
                            <div class="progress-info">
                            <div class="progress-label">
                            <span>ร้านค้าที่ 4 ทำรายได้ในเดือนนี้</span>
                            </div>
                            <div class="progress-percentage">
                                <span>15%</span>
                            </div>
                            </div>
                            <div class="progress">
                            <div class="progress-bar bg-warning" role="progressbar" aria-valuenow="15" aria-valuemin="0" aria-valuemax="100" style="width: 15%;"></div>
                            </div>
                        </div>

                        <div class="progress-wrapper">
                            <div class="progress-info">
                            <div class="progress-label">
                            <span>ร้านค้าที่ 5 ทำรายได้ในเดือนนี้</span>
                            </div>
                            <div class="progress-percentage">
                                <span>10%</span>
                            </div>
                            </div>
                            <div class="progress">
                            <div class="progress-bar bg-danger" role="progressbar" aria-valuenow="10" aria-valuemin="0" aria-valuemax="100" style="width: 10%;"></div>
                            </div>
  </div>-->
  <!-- e content -->
  <!-- </div> -->
  <!-- <div class="col-lg-5">
  <b>เดือนนี้</b>-->
  <!-- s content -->
  <!-- <div class="progress-wrapper">
                        <div class="progress-info">
                        <div class="progress-label">
                            <span>ร้านค้าที่ 1 ทำรายได้ในเดือนนี้</span>
                        </div>
                        <div class="progress-percentage">
                            <span>30%</span>
                        </div>
                        </div>
                        <div class="progress">
                        <div class="progress-bar bg-success" role="progressbar" aria-valuenow="30" aria-valuemin="0" aria-valuemax="100" style="width: 30%;"></div>
                        </div>
                    </div>

                    <div class="progress-wrapper">
                        <div class="progress-info">
                        <div class="progress-label">
                        <span>ร้านค้าที่ 2 ทำรายได้ในเดือนนี้</span>
                        </div>
                        <div class="progress-percentage">
                            <span>25%</span>
                        </div>
                        </div>
                        <div class="progress">
                        <div class="progress-bar bg-info" role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" style="width: 25%;"></div>
                        </div>
                    </div>

                    <div class="progress-wrapper">
                        <div class="progress-info">
                        <div class="progress-label">
                        <span>ร้านค้าที่ 3 ทำรายได้ในเดือนนี้</span>
                        </div>
                        <div class="progress-percentage">
                            <span>20%</span>
                        </div>
                        </div>
                        <div class="progress">
                        <div class="progress-bar bg-info" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%;"></div>
                        </div>
                    </div>

                    <div class="progress-wrapper">
                        <div class="progress-info">
                        <div class="progress-label">
                        <span>ร้านค้าที่ 4 ทำรายได้ในเดือนนี้</span>
                        </div>
                        <div class="progress-percentage">
                            <span>15%</span>
                        </div>
                        </div>
                        <div class="progress">
                        <div class="progress-bar bg-warning" role="progressbar" aria-valuenow="15" aria-valuemin="0" aria-valuemax="100" style="width: 15%;"></div>
                        </div>
                    </div>

                    <div class="progress-wrapper">
                        <div class="progress-info">
                        <div class="progress-label">
                        <span>ร้านค้าที่ 5 ทำรายได้ในเดือนนี้</span>
                        </div>
                        <div class="progress-percentage">
                            <span>10%</span>
                        </div>
                        </div>
                        <div class="progress">
                        <div class="progress-bar bg-danger" role="progressbar" aria-valuenow="10" aria-valuemin="0" aria-valuemax="100" style="width: 10%;"></div>
                        </div>
  </div>-->
  <!-- e content -->
  <!-- </div> -->
</template>

<script>
import Dashboard from "@/stores/Dashboard";
import router from "@/router";
import BarChart from "@/layout/BarChart.js";
export default {
  name: "Dashboard",
  components: {
    BarChart
  },
  data() {
    return {
      datacollection: null
    };
  },
  methods: {
    getDashboard: async function() {
      if (!localStorage.access_token) router.push("/");
      let optionts = {
        access_token: localStorage.access_token
      };
      await Dashboard.dispatch("getDashboard", optionts);
      if (Dashboard.state.dashboard.status == 200) {
        this.datacollection = {
          labels: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
          ],
          datasets: [
            {
              label: "รายได้ของแต่ละเดือน",
              backgroundColor: "#2dce89",
              data: Dashboard.state.dashboard.bar_chart
            }
          ]
        };
      }
    }
  },
  async mounted() {
    await this.getDashboard();
  }
};
</script>